export const SET_ACCEPTED_ORDERS = 'SET_ACCEPTED_ORDERS';
export const SET_PENDING_ORDERS = 'SET_PENDING_ORDERS';
export const SET_ORDER_TO_ACCEPTED = 'SET_ORDER_TO_ACCEPTED';
export const SET_ORDER_TO_DECLINED = 'SET_ORDER_TO_DECLINED';
export const SET_ORDER_TO_DELIVERED = 'SET_ORDER_TO_DELIVERED';
export const SET_HISTORY_ORDERS = 'SET_HISTORY_ORDERS';
export const SET_SUBMITTING = 'SET_SUBMITTING';
export const CLEAR_SUBMITTING = 'CLEAR_SUBMITTING';

export const DELIVERED = 'DELIVERED';
export const ENROUTE = 'ENROUTE';
export const ARRIVED = 'ARRIVED';